import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export const TeamAbout = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-blue-50 to-background">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6">
              Meet the Safeway Family
            </h2>
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
              Founded in 2014, Safeway Roofing & Chimney began as a family vision to provide 
              Long Island homeowners with honest, reliable roofing services. What started as a 
              small operation has grown into one of the region's most trusted roofing contractors.
            </p>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
                <p className="text-muted-foreground">
                  <span className="font-medium text-primary">Family Heritage:</span> Three generations 
                  of construction expertise passed down through our family
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
                <p className="text-muted-foreground">
                  <span className="font-medium text-primary">Local Focus:</span> Born and raised on 
                  Long Island, we understand our community's unique needs
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-primary rounded-full mt-2"></div>
                <p className="text-muted-foreground">
                  <span className="font-medium text-primary">Continuous Training:</span> Our team 
                  regularly attends GAF training programs and industry certifications
                </p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              <Badge variant="secondary" className="bg-primary text-primary-foreground">
                GAF Master Elite
              </Badge>
              <Badge variant="secondary" className="bg-accent text-accent-foreground">
                Licensed & Insured
              </Badge>
              <Badge variant="secondary">BBB Accredited</Badge>
              <Badge variant="secondary">10+ Years Experience</Badge>
            </div>
          </div>

          <Card className="overflow-hidden">
            <CardContent className="p-0">
              <div className="aspect-[4/3] bg-gradient-to-br from-primary/20 to-blue-50 flex items-center justify-center">
                <div className="text-center">
                  <div className="w-24 h-24 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl font-bold text-primary-foreground">SW</span>
                  </div>
                  <h3 className="text-xl font-bold text-primary mb-2">Safeway Team</h3>
                  <p className="text-muted-foreground">Professional team photo coming soon</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="mt-16">
          <Card className="bg-primary text-primary-foreground p-8">
            <div className="text-center max-w-3xl mx-auto">
              <h3 className="text-2xl font-bold mb-4">Our Mission</h3>
              <p className="text-primary-foreground/90 text-lg leading-relaxed">
                "To protect Long Island families with superior roofing solutions, backed by 
                unmatched craftsmanship, honest communication, and a commitment to excellence 
                that spans generations. Every roof we install carries our family name and our 
                promise of lasting protection."
              </p>
              <div className="mt-6 text-primary-foreground/80">
                — The Safeway Roofing Family
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};